import apiNetCore from '../../../../services/apiNetCore';

export const getIdCidades = record => ({
  idCidadeOrigem: record.idCidadeColeta || record.idCidadeOrigem,
  idCidadeDestino: record.idCidadeEntrega || record.idCidadeDestino,
});

export const getIdEstados = record => ({
  idEstadoOrigem: record.idEstadoColeta || record.idEstadoOrigem,
  idEstadoDestino: record.idEstadoEntrega || record.idEstadoDestino,
});

export const getPedagioRota = idCidades =>
  apiNetCore.post('lotes-integracao/pedagio-rota', idCidades);

export const extrairICMS = (aliquotas, estados) =>
  aliquotas.filter(
    aliquota =>
      aliquota.idestadoorigem === estados.idEstadoOrigem &&
      aliquota.idestadodestino === estados.idEstadoDestino
  )[0]?.valor || 0;

export const extrairPedagioRota = (rotas, cidades) =>
  rotas.filter(
    rota =>
      rota.idCidadeOrigem === cidades.idCidadeOrigem &&
      rota.idCidadeDestino === cidades.idCidadeDestino
  )[0]?.pedagio || 0;
